import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@/api";
import {
  setCurrentPlan,
  setAvailablePlans,
  setPermissions,
  setLoading,
  setError,
  setHasAttemptedFetch,
} from "./reducer";

export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await api.plans.list();
      dispatch(setAvailablePlans(response.data));

      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Ошибка загрузки планов";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);

export const fetchCurrentPlan = createAsyncThunk(
  "plans/fetchCurrentPlan",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await api.plans.getCurrent();
      dispatch(setCurrentPlan(response.data));

      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Ошибка загрузки текущего плана";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);

export const fetchPermissions = createAsyncThunk(
  "plans/fetchPermissions",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await api.plans.permissions();
      dispatch(setPermissions(response.data));

      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Ошибка загрузки разрешений";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);

export const fetchPlansData = createAsyncThunk(
  "plans/fetchPlansData",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));
      dispatch(setHasAttemptedFetch(true));

      // Загружаем все данные параллельно
      const [plansResponse, currentPlanResponse, permissionsResponse] =
        await Promise.all([
          api.plans.list(),
          api.plans.getCurrent(),
          api.plans.permissions(),
        ]);

      dispatch(setAvailablePlans(plansResponse.data));
      dispatch(setCurrentPlan(currentPlanResponse.data));
      dispatch(setPermissions(permissionsResponse.data));

      return {
        plans: plansResponse.data,
        currentPlan: currentPlanResponse.data,
        permissions: permissionsResponse.data,
      };
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Ошибка загрузки данных о планах";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
  {
    // Отключаем автоматические ретраи в Redux Toolkit
    condition: (_, { getState }) => {
      const state = getState() as any;
      // Не запускать, если уже идет загрузка
      if (state.plans.isLoading) {
        return false;
      }
      return true;
    },
  },
);

// Обновление текущего плана (для будущего использования)
export const updateCurrentPlan = createAsyncThunk(
  "plans/updateCurrentPlan",
  async (planId: number, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await api.plans.get(planId);
      dispatch(setCurrentPlan(response.data));

      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Ошибка обновления плана";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);
